// extracted by mini-css-extract-plugin
export default {"logout":"logoutComponent_logout__eqUh6","logout__linkIcon":"logoutComponent_logout__linkIcon__IDOsb"};